import PluginHeader from "../PluginHeader";
import PartnerCard from "../PartnerCard";
import partnersData from "../../partner-data/partners.json";
import { Helmet, HelmetProvider } from "react-helmet-async";

const FatooraPlugin = () => {
  return (
    <>
      <HelmetProvider>
        <Helmet>
          <title>Fatoora E-invoice phase 2 in Saudi Arabia - Aronium</title>
          <meta name="description" content="Stay compliant with Saudi Arabia E-invoicing phase 2 using Fatoora plugin" />
        </Helmet>
      </HelmetProvider>

      <section className="py-8">
        <div className="max-w-screen-xl mx-auto text-center">
          <h1 className="text-4xl mb-4">
            Fatoora E-Invoice Phase 2 in Saudi Arabia
          </h1>
          <p>
            Seamlessly integrate Aronium with Fatoora to ensure compliance with ZATCA Phase 2 electronic invoicing requirements.
          </p>
          <p className="mt-1 text-sm">
            Available for both Simplified (<strong>B2C</strong>) and Standard (<strong>B2B</strong>) invoices.
          </p>
        </div>
      </section>

      <p className='my-12'>
        <img alt="Fatoora - E-invoicing phase 2 in Saudi Arabia" src="/images/logo/fatoora-logo.png" className="mx-auto h-24 md:h-32" />
      </p>

      <div className="py-20 bg-[#64bab0]">
        <PluginHeader price="8"
        note={[ 
              "Compliant with Simplified (B2C) & Standard (B2B) invoices for ZATCA Phase 2.",
              "Installation is handled exclusively through our authorized partners."
        ]}  />
      </div>
      <div className="pt-24 pb-12">
        <div className="relative max-w-7xl mx-auto text-center px-8 lg:px-12">
          <h2 className="text-5xl text-gray-800 leading-tight mb-8">
            Why use <span className='font-semibold'>Fatoora</span> plugin?
          </h2>
          <p className="text-lg text-gray-600 mx-auto">
            Aronium's <span className='font-semibold'>Fatoora</span> plugin ensures compliance with Saudi Arabia's ZATCA Phase 2 E-invoicing regulations, streamlining digital invoicing for businesses.
          </p>
          
        </div>
      </div>

      <div className='mb-20'><img
        alt="Saudi Arabia E-invoicing phase 1"
        src="/images/zatca-logo-dark.svg"
        className="mx-auto h-24 md:h-32 transition-transform duration-300 hover:scale-110"
      /></div>

      <div className="pb-24">
        <div className="max-w-6xl mx-auto px-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-8">
          <div className="bg-white p-8 shadow-lg rounded-lg border">
            <h3 className="text-2xl font-semibold text-gray-800">ZATCA compliance</h3>
            <p className="mt-4 text-gray-600">
              Fully compliant with Saudi Arabia's electronic invoicing regulations, ensuring secure and seamless invoicing.
            </p>
          </div>
          <div className="bg-white p-8 shadow-lg rounded-lg border">
            <h3 className="text-2xl font-semibold text-gray-800">Seamless integration</h3>
            <p className="mt-4 text-gray-600">
              Easily integrate Fatoora with Aronium for a smooth invoicing process without disruptions to your business operations.
            </p>
          </div>
        </div>
      </div>

      <div className="bg-sky-700 py-24 text-center text-white">
        <div className="max-w-6xl mx-auto px-4">

          <h2 className="text-6xl font-bold mb-6">Authorized partners</h2>

          <p className=" mb-10">
            For further information or to begin using the Fatoora phase 2 plugin, please contact one of our authorized partners listed below:
          </p>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            {partnersData.find(p => p.country === "Saudi Arabia")?.partners.map((partner) => (
              <PartnerCard key={partner.name} partner={partner} />
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default FatooraPlugin;